export interface ExternalNavLink {
  url: string
  /** Nazwa własna — celowo poza i18n. */
  label: string
  descriptionKey: string
}

export const SHOP_LINK: ExternalNavLink = {
  url: 'https://fud24.pl',
  label: 'FUD24.pl',
  descriptionKey: 'nav.visitShop',
}
